<div class="bmc-rotate-keys">

  <h5 class="bmc-rotate-keys__title">{{'ENCRYPTION.TAB_ROTATE' | translate }}</h5>

  <bzg-message class="" [showCloseBtn]="false" [status]="'warning'">
    <div class="bz-space--inline-s "> {{'ENCRYPTION.KEY_ROTATION_TITLE' | translate}} </div>
    <div class="bz-space--inline-s "> {{'ENCRYPTION.KEY_ROTATION_WARNING' | translate}} </div>

    <bzg-button-secondary class="rotate-key__btn" [disabled]="isInProgressOperation()"
      (click)="rotateKeys()">
      {{'ENCRYPTION.KEY_ROTATION' | translate}}
    </bzg-button-secondary>
  </bzg-message>

  <bzg-message *ngIf="isMasterKeyCrationEnabled && !ExistsMasterEncryptionKey" class="" [showCloseBtn]="false" [status]="'info'">
    <div class="bz-space--inline-s "> {{'ENCRYPTION.CREATE_MASTER_KEY_WARNING' | translate}} </div>

    <bzg-button-secondary 
      class="create-master__btn" 
      [disabled]="isInProgressOperation()"
      (click)="createMasterKey()">
      {{'ENCRYPTION.CREATE_MASTER_KEY' | translate}}
    </bzg-button-secondary>
  </bzg-message>

  <div class="bmc-rotate-keys-loading bz-color-border--theme-400" *ngIf="isInProgressOperation()">
    <bz-loading [size]="'m'" class="bmc-rotate-keys-loading__text">
      {{ _currentOperation === 'rotate' ? ('ENCRYPTION.ROTATING_KEYS' | translate) : ('ENCRYPTION.CREATING_MASTER_KEYS' | translate) }}</bz-loading>
  </div>

  <div class="bmc-rotate-keys-status bmc-rotate-keys-status--error" *ngIf="isFailedOperation()">
    <div class="bmc-rotate-keys-status__advice bmc-rotate-keys-status__advice--error">
      <span class="bmc-rotate-keys-status__advice__text">
        <bzg-icon [nameIcon]="'icon-error'" [size]="22" [color]="'error'" class="bz-space--inline-s"></bzg-icon>
        {{'ENCRYPTION.FAILED_TITLE' | translate}}
      </span>
    </div>
    <div class="bmc-rotate-keys-status__label" [ngClass]="['bmc-rotate-keys-status__label--active']">
      <span class="bmc-rotate-keys-status__label__text">
        {{'GLOBAL.AN_ERROR_HAS_OCCURRED' | translate}}
      </span>
    </div>
  </div>

  <div class="bmc-rotate-keys-status bmc-rotate-keys-status--success" *ngIf="isSucceededOperation()">
    <div class="bmc-rotate-keys-status__advice bmc-rotate-keys-status__advice--success">
      <span class="bmc-rotate-keys-status__advice__text bz-color--theme-400">
        <bzg-icon [nameIcon]="'icon-boolean'" [size]="22" [color]="'success'" class="bz-space--inline-s"></bzg-icon>
        {{'ENCRYPTION.SUCCESS_TITLE' | translate}}
      </span>
    </div>
    <div class="bmc-rotate-keys-status__label">
      <span class="bmc-rotate-keys-status__label__text">
        {{_currentOperation === 'rotate' ? ('ENCRYPTION.SUCCESS_MSG' | translate) : ('ENCRYPTION.SUCCESS_CREATE_MASTER_KEY' | translate)}}
      </span>
    </div>
  </div>
</div>